<svg
  width="33"
  height="33"
  viewBox="0 0 33 33"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect
    x="9.61627"
    y="8.62305"
    width="20.4407"
    height="2.18671"
    rx="1.09336"
    transform="rotate(45 9.61627 8.62305)"
    fill="#FF3434"
  />
  <rect
    x="24.07"
    y="10.1693"
    width="20.4407"
    height="2.18671"
    rx="1.09336"
    transform="rotate(135 24.07 10.1693)"
    fill="#FF3434"
  />
  <g filter="url(#filter0_f_713_2354)">
    <rect
      x="9.61627"
      y="8.62305"
      width="20.4407"
      height="2.18671"
      rx="1.09336"
      transform="rotate(45 9.61627 8.62305)"
      fill="#FF3434"
    />
    <rect
      x="24.07"
      y="10.1693"
      width="20.4407"
      height="2.18671"
      rx="1.09336"
      transform="rotate(135 24.07 10.1693)"
      fill="#FF3434"
    />
  </g>
  <circle
    cx="16.5942"
    cy="24.4686"
    r="0.544223"
    transform="rotate(-90 16.5942 24.4686)"
    stroke="#FF3434"
    stroke-width="0.1"
  />
  <circle
    cx="16.5942"
    cy="8.59422"
    r="0.544223"
    transform="rotate(-90 16.5942 8.59422)"
    stroke="#FF3434"
    stroke-width="0.1"
  />
  <circle
    cx="7.59422"
    cy="16.5942"
    r="0.544223"
    stroke="#FF3434"
    stroke-width="0.1"
  />
  <circle
    cx="23.4686"
    cy="16.5942"
    r="0.544223"
    stroke="#FF3434"
    stroke-width="0.1"
  />
  <defs>
    <filter
      id="filter0_f_713_2354"
      x="4.52292"
      y="5.0759"
      width="23.0942"
      height="23.0943"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="BackgroundImageFix"
        result="shape"
      />
      <feGaussianBlur
        stdDeviation="2"
        result="effect1_foregroundBlur_713_2354"
      />
    </filter>
  </defs>
</svg>
